import React, { useState } from 'react';
import PropTypes from 'prop-types';
import type { AlertProps } from './Alert.types';
import Icon from '../icon/Icon';
import './alert.scss';

const Alert = ({ message, iconName, icon, borderRadius, color, center, small, closed }: AlertProps) => {
  const [show, setShow] = useState(true);

  const iconType =
    color === 'normal' ? 'bell' :
      color === 'success' ? 'check' : 'alert-triangle';
  const isBorderRadius = borderRadius ? 'sb-alert--borderRadius' : '';
  const isCenter = center ? 'sb-alert--center' : 'sb-alert--left';
  const isShow = show ? 'sb-alert--show' : '';
  const isSmall = small ? 'sb-alert--small' : '';

  return (
    <div
      className={['sb-alert',
        `sb-alert--${color}`,
        isBorderRadius,
        isCenter,
        isShow,
        isSmall].join(' ')}
      data-testid="sb-alert"
    >
      <div
        className="flex justify-center items-center" data-testid="sb-alert__container"
      >
        {icon &&
          <Icon
            iconName={iconName ? iconName : iconType}
            size={small ? 13 : 16}
            className="mr-sm" />
        }
        <span
          data-testid="sb-alert__message"
          className="sb-alert__message"
          dangerouslySetInnerHTML={{
            __html: message
          }}
        />
      </div>
      {closed &&
        <span
          className="sb-alert__close"
          data-testid="sb-alert__close"
          onClick={() => setShow(false)}
        >
          <Icon
            iconName="x"
            size={small ? 15 : 20}
          />
        </span>
      }
    </div>
  );
};

Alert.propTypes = {
  /**
 * Alert message
 */
  message: PropTypes.string.isRequired,
  /**
* Has icon?
*/
  icon: PropTypes.bool,
  /**
* IconName
*/
  iconName: PropTypes.string,
  /**
* Color of alert
*/
  color: PropTypes.oneOf(['normal', 'warning', 'success', 'error']),
  /**
* Has border radius?
*/
  borderRadius: PropTypes.bool,
  /**
* Alignment
*/
  center: PropTypes.bool,
  /**
* Small
*/
  small: PropTypes.bool,
  /**
* Closed
*/
  closed: PropTypes.bool,
};

Alert.defaultProps = {
  message: "alert text",
  iconName: "",
  icon: true,
  borderRadius: true,
  color: "normal",
  center: true,
  small: false,
  closed: true,
};

export default Alert;